import { render, staticRenderFns } from "./ReportCreate.vue?vue&type=template&id=67da2046"
import script from "./ReportCreate.vue?vue&type=script&lang=js"
export * from "./ReportCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports